/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TSendSurveyAnswerModel,
  ISendSurveyAnswerRequest,
  IMappers,
  ISendSurveyAnswerResponse,
  ISendSurveyAnswerResponseError,
  TSendSurveyAnswerResponse,
} from './types';

const defaultConfig: TSendSurveyAnswerModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'deal-rent-announcements',
  pathApi: '/v1/send-survey-answer/',
  hostType: 'api',
} as TSendSurveyAnswerModel;

function createSendSurveyAnswerModel(parameters: ISendSurveyAnswerRequest): TSendSurveyAnswerModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISendSurveyAnswerOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ISendSurveyAnswerRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchSendSurveyAnswer<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ISendSurveyAnswerOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TSendSurveyAnswerResponse
> {
  const { response, statusCode } = await httpApi.fetch(createSendSurveyAnswerModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISendSurveyAnswerResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ISendSurveyAnswerResponseError);
    }
  }

  return { response, statusCode } as TSendSurveyAnswerResponse;
}

export { defaultConfig, createSendSurveyAnswerModel, fetchSendSurveyAnswer };
